<template>
	<el-affix position="top">
		<el-page-header @back="goBack">
			<template #icon>
				<el-icon>
					<ArrowLeftBold />
				</el-icon>
			</template>
			<template #title>
				返回
			</template>
			<template #content>
				<span class="content-title">常德营商地图</span>
			</template>
		</el-page-header>
	</el-affix>
	<!-- 	<div class="header">
		<div class="left">
			常德营商地图
		</div>
		<div class="right">
			<span v-html="datetime.nowTime"></span>
		</div>
	</div> -->
</template>

<script>
	import {
		reactive
	} from 'vue'
	export default {
		components: {},
		setup() {
			function goBack() {
				window.history.back();
			}

			const datetime = reactive({
				nowTime: ''
			})
			//顶部时间
			function getTime() {
				var myDate = new Date();
				var myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
				var myMonth = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
				var myToday = myDate.getDate(); //获取当前日(1-31)
				var myDay = myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
				var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

				datetime.nowTime = myYear + '年' + fillZero(myMonth) + '月' + fillZero(myToday) + '日' +
					'&nbsp;' + week[myDay] + '&nbsp;';
			}
			// 格式处理 加小于10时前面加0
			function fillZero(str) {
				var realNum;
				if (str < 10) {
					realNum = '0' + str;
				} else {
					realNum = str;
				}
				return realNum;
			}
			//
			setInterval(getTime, 1000);

			return {
				goBack,
				datetime,
				getTime,
				fillZero
			}
		}
	}
</script>

<style lang="scss">
	.el-page-header__header {
		display: flex;
		background: #37a9fe;
		justify-content: space-between;
		align-items: center;
		height: 50px;
		color: #fff;
		font-weight: bold;
		padding: 0px 10px;
		margin: 0px;
		
		.el-page-header__title {
			font-size: 16px;
		}

		.content-title {
			color: #fff;
		}
	}
</style>